import { RootState } from "../../../../store";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";
import { ResourceExplorerData } from "../../../../../services/cloudchipr.api";

export const resourceExplorerDataSelector = (
  state: RootState,
): ResourceExplorerData | undefined => {
  return resourceExplorerStateSelector(state).data ?? undefined;
};
